
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Mechanical_Ventilation",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Mechanical_Ventilation.vue